import type { InputHTMLAttributes } from "react";

import { cn } from "@/lib/utils";

type ClientInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
};

export function ClientInput({ className, id, label, hint, ...props }: ClientInputProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium" htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className={cn(
          "w-full rounded-xl border border-border/70 bg-background/70 px-3 py-2 text-sm shadow-sm outline-none transition",
          "placeholder:text-muted-foreground/80 focus:border-foreground/20 focus:ring-2 focus:ring-ring/30",
          className,
        )}
        {...props}
      />
      {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
    </div>
  );
}

